<template>
  <div>
    <div id="bk1" style="display: none" class="bk1"></div>
    <div id="openImg" style="display: none" class="openImg">
      <div class="bn" @click="open()">
        <img src="../assets/img/icon_close@2x.png" alt="" />
      </div>
      <div class="three">
        <img :src="this.img" alt="" />
        <div class="title">{{ this.title }}</div>
        <div class="content">
          <span>{{ this.content }}</span>
        </div>
      </div>
    </div>
    <div class="bk">
      <div>重点案例</div>
    </div>
    <div class="two">
      <span class="check">
        <router-link :to="{ path: '/project' }">
          <p>城市与建筑智能化</p>
        </router-link>
        <i></i></span>
      <!-- <span
        ><router-link :to="{ path: '/project2' }"
          ><p>智能交通</p></router-link
        ></span
      > -->
    </div>
    <div class="content">
      <lz-menu :menuItems="menuItems" :iActiveColor="iActiveColor" :checkedIndex="checkedIndex"
        @clickLzMenuItem="clickMenuItem" />
      <!-- <ul>
            <li @click="selectBySub('建筑智能化-金融行业')">平安城市</li>
            <li @click="selectBySub2('建筑智能化-金融行业')">金融行业</li>
            <li @click="selectBySub2('建筑智能化-政府部门')">政府部门</li>
            <li @click="selectBySub2('建筑智能化-公安边防')">公安边防</li>
        </ul> -->

      <div class="bottom">
        <div v-for="(person, index) in arr" :key="index">
          <div class="img">
            <img @click="open(person.imgPath, person.title, person.content)" :src="person.imgPath" alt="" />
          </div>
          <span>{{ person.title }}</span>
        </div>
      </div>
    </div>

    <div class="bm">
      <span>
        版权所有©深圳昌恩智能股份有限公司　
        <a style="color: #fff" target="_blank" href="http://beian.miit.gov.cn">粤ICP备17113788号</a></span>
    </div>
  </div>
</template>

<script>
import LzMenu from './LzMenu.vue'
// import { scrollHandler } from "../utils/scrollHandler";
export default {
  name: 'project',
  components: {
    LzMenu
  },
  data() {
    return {
      // scrollHandler,
      menuItems: [
        {
          id: 0,
          name: '全部案例'
        },
        {
          id: 1,
          name: '平安城市'
        },
        {
          id: 2,
          name: '金融行业'
        },
        {
          id: 3,
          name: '政府部门'
        },
        {
          id: 4,
          name: '公安边防'
        },
        {
          id: 5,
          name: '旅游景点'
        },
        {
          id: 6,
          name: '文博系统'
        },
        {
          id: 7,
          name: '医疗教育'
        },
        {
          id: 8,
          name: '小区酒店'
        },
        {
          id: 9,
          name: '企业单位'
        }
      ],
      checkedIndex: 0,
      iActiveColor: '#FFFFFF',
      subCategory: '1',
      status: 1,
      type: 2,
      // category: "建筑智能化-平安城市",
      category: '',
      parentCategory: '建筑智能化',
      arr: [],
      imgPath: '',
      img: '',
      title: '',
      content: '',
      pageNum: 1,
      isLoading: false
    }
  },
  mounted() {
    const tabId = this.$route.params.tabId
    const index = this.menuItems.findIndex(item => item.id == tabId)
    console.log("tab:" + tabId + ", index: " + index)
    if (index != -1) {
      this.clickMenuItem({ ...this.menuItems[index], index })
    } else {
      this.selectBySub()
    }

    console.log(this.$route.query.id)
    if (this.$route.query.id) {
      window.scrollTo(0, 0)
    }
    this.scrollHandler()
  },
  destroyed() {
    window.removeEventListener('scroll', function () {
      console.log('移除')
    })
  },
  methods: {
    open(img, title, content) {
      //   //跳转当前页面顶部
      //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //         if (scrollTop > 0) {
      //             document.documentElement.scrollTop = document.body.scrollTop = 0
      //   }
      this.img = img
      this.title = title
      this.content = content
      var nowStatus = document.getElementById('bk1')
      var bkStatus = document.getElementById('openImg')
      if (nowStatus.style.display == 'none') {
        nowStatus.style.display = 'block'
        bkStatus.style.display = 'block'
        this.scrollPosition = window.scrollY
        window.scrollTo(0, 0)
      } else {
        nowStatus.style.display = 'none'
        bkStatus.style.display = 'none'
        window.scrollTo(0, this.scrollPosition)
      }
    },
    clickMenuItem: function (item) {
      this.checkedIndex = item.index
      if (item.name == '全部案例') {
        this.parentCategory = '建筑智能化'
        this.category = ''
        this.selectBySub()
        console.log('选中全部')
      }
      if (item.name == '平安城市') {
        this.category = '建筑智能化-平安城市'
        this.selectBySub()
      }
      if (item.name == '金融行业') {
        this.category = '建筑智能化-金融行业'
        this.selectBySub()
      }
      if (item.name == '政府部门') {
        this.category = '建筑智能化-政府部门'
        this.selectBySub()
      }
      if (item.name == '公安边防') {
        console.log('222')
        this.category = '建筑智能化-公安边防'
        this.selectBySub()
      }
      if (item.name == '旅游景点') {
        this.category = '建筑智能化-旅游景点'
        this.selectBySub()
      }
      if (item.name == '文博系统') {
        this.category = '建筑智能化-文博系统'
        this.selectBySub()
      }
      if (item.name == '医疗教育') {
        this.category = '建筑智能化-医疗教育'
        this.selectBySub()
      }
      if (item.name == '小区酒店') {
        this.category = '建筑智能化-小区酒店'
        this.selectBySub()
      }
      if (item.name == '企业单位') {
        this.category = '建筑智能化-企业单位'
        this.selectBySub()
      }
    },
    scrollHandler() {
      this.isLoading = true //是否有数据可以加载
      window.onscroll = async () => {
        // 距离底部200px时加载一次
        let bottomOfWindow =
          document.documentElement.offsetHeight -
          document.documentElement.scrollTop -
          window.innerHeight <=
          200
        if (bottomOfWindow && this.isLoading == true) {
          this.pageNum++ //每次分页+1
          this.request
            .get(`/${this.status}/${this.type}`, {
              params: {
                category: this.category,
                parentCategory: this.parentCategory,
                pageSize: 10,
                pageNum: this.pageNum
              }
            })
            .then(res => {
              // console.log("ddddd", res.data.data);
              this.arr = [...this.arr, ...res.data.data]
              for (var i = 0; i < this.arr.length; i++) {
                this.arr[i].content = this.getSimpleText(this.arr[i].content)
                // console.log(this.arr[i].content + "!!!!!");
              }
            })
          console.log('调用滚动方法')
          //自己封装的请求数据的方法
          //     //有数据的时候加载
          //     if(res.data.length > 0){
          //         this.list.push(...res.data);//追加数据 使用 ...语法
          //         isLoading = true;
          //     }else{
          //         this.$notify({
          //             title: '温馨提示：',
          //             message: '暂无更多数据信息！',
          //             position: 'bottom-right'
          //         });
          //         isLoading = false;//无数据可以加载
          //     }
        }
      }
    },
    selectBySub() {
      this.pageNum = 1
      this.request
        .get(`/${this.status}/${this.type}`, {
          // 问题：   如何判断输入了那些条件只传查询条件 空的不传   ??????
          params: {
            category: this.category,
            parentCategory: this.parentCategory,
            pageSize: 10
          }
        })
        .then(res => {
          this.arr = res.data.data
          for (var i = 0; i < this.arr.length; i++) {
            this.arr[i].content = this.getSimpleText(this.arr[i].content)
            console.log(this.arr[i].content + '!!!!!')
          }
        })
    },
    selectBySub2(category) {
      this.request
        .get(`/${this.status}/${this.type}`, {
          // 问题：   如何判断输入了那些条件只传查询条件 空的不传   ??????
          params: {
            category: category,
            parentCategory: this.parentCategory,
            pageSize: 10
          }
        })
        .then(res => {
          this.arr = res.data.data
          for (var i = 0; i < this.arr.length; i++) {
            this.arr[i].content = this.getSimpleText(this.arr[i].content)
            console.log(this.arr[i].content + '!!!!!')
          }
        })
    },
    getSimpleText(html) {
      const re1 = new RegExp('<.+?>', 'g') // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const arrEntities = {
        lt: '<',
        gt: '>',
        nbsp: ' ',
        amp: '&',
        quot: '"',
        ldquo: '“',
        mdash: '—',
        rdquo: '”'
      }
      return html
        .replace(re1, '')
        .replace(
          /&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/gi,
          function (all, t) {
            return arrEntities[t]
          }
        )
    }
  }
}
</script>

<style scoped>
.content {
  min-height: 800px;
}

.bk1 {
  position: absolute;
  width: 100vw;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.77);
  display: none;
}

.bk {
  position: relative;
  width: 100vw;
  height: 87.3333vw;
  background-image: url(../assets/img/重点工程案例banner_mob1.png);
  background-size: 100% 100%;
}

.bk div {
  position: absolute;
  top: 39.4667vw;
  /* left: 25.3333vw; */
  left: 50%;
  transform: translateX(-50%);
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  line-height: 8vw;
  letter-spacing: 1.8667vw;
  font-size: 6.4vw;
}

ul {
  display: block;
  width: 100vw;
  height: 8vw;
  margin-bottom: 5.3333vw;
}

.openImg {
  position: absolute;
  z-index: 12;
  display: none;
  top: 0px;
  left: 50%;
  transform: translate(-50%, 0);
}

.openImg .bn {
  width: 92vw;
  height: 4.2667vw;
  float: right;
  margin: 4.2667vw auto 0;
}

.openImg .bn img {
  width: 4.2667vw;
  height: 4.2667vw;
  float: right;
  background-image: url('../assets/img/icon_close.svg');
  background-size: 100% 100%;
}

.openImg .three {
  margin: 14.6667vw auto 0px;
  width: 92vw;
  height: 124.2667vw;
  background-color: #ffff;
}

.openImg .three img {
  display: block;
  width: 84vw;
  height: 56vw;
  margin-left: 4vw;
  padding-top: 4.2667vw;
}

.openImg .three .title {
  margin-left: 4vw;
  margin-top: 5.3333vw;
  color: #1d1e20;
  letter-spacing: 0.2vw;
  line-height: 5.3333vw;
  font-size: 3.7333vw;
  margin-bottom: 1.6vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.openImg .three .content {
  width: 84vw;
  height: 48vw;
  margin: 1.6vw auto;
  overflow: hidden;
}

.openImg .three .content span {
  opacity: 0.44;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d1d1d;
  line-height: 20px;
  letter-spacing: 0.5px;
}

ul li {
  display: inline-block;
  float: left;
  margin-left: 4vw;
  width: 21.3333vw;
  height: 8vw;
  text-align: center;
  line-height: 8vw;
  background-color: #140047;
  border-radius: 4vw;
  color: #ffffff;
  font-size: 3.2vw;
}

ul li:nth-child(4) {
  display: inline-block;
  float: left;
  margin-left: 4vw;
  width: 20vw;
  height: 8vw;
  text-align: center;
  line-height: 8vw;
  background-color: #140047;
  border-radius: 4vw;
  color: #ffffff;
  font-size: 3.2vw;
}

.two {
  width: 100vw;
  height: 10.6667vw;
  text-align: center;
  margin: 0 100px;
}

.two span {
  position: relative;
  display: inline-block;
  float: left;
  width: 50vw;
  height: 10.6667vw;
  text-align: center;
  line-height: 10.6667vw;
}

.two span p {
  color: rgba(0, 0, 0, 0.3);
  font-size: 3.2vw;
}

.two .check p {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #140047;
  font-size: 3.2vw;
}

.check i {
  position: absolute;
  text-align: center;
  position: absolute;
  left: 13.8667vw;
  bottom: 0.2667vw;
  width: 22.4vw;
  height: 0.2667vw;
  background-color: #140047;
  border-radius: 0.2667vw;
}

.bottom {
  margin-top: 5.3333vw;
  width: 92vw;
  margin: 0 auto;
}

.bottom .img img {
  width: 92vw;
  height: 44vw;
}

.bottom span {
  display: block;
  margin: 4vw;
  height: 5.3333vw;
  line-height: 5.3333vw;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/project.vue